(function($) {
    History.Adapter.bind(window,'statechange',function() {
        if ($(".product-listing").length > 0 || $(".filters-row").length > 0) {
            if(!obj.ajaxClickHandlerState) {
                var n = location.search == "" ? "" : "?" + location.search;
                var url = location.pathname + n;
                obj.getCollectionContent(url);
            }
            obj.ajaxClickHandlerState = false;
        }
    });

    var queryParams = {};
    var obj = {
        init: function() {
            queryParams = this.getQueryParams();
            this.initSidebar();
            this.initToolbar();
            this.currentFilter();
        },
        currentFilter : function(){
            var args = [];
            if(queryParams.sort_by || queryParams.constraint || queryParams.price){
                $('.clear_all_filter').show();
                args = queryParams.constraint ? queryParams.constraint.split('+'):[];
                $.each(args,function(i,e){
                    $('[value="'+e+'"]').prop('checked',true);
                })
            }
            if(typeof current_collection != typeof undefined && current_collection != 'Products'){
                console.log('show');
                $('.clear_all_filter').show();
            }
            if($('.search-filter-input').length > 0 && $().slider ) {
                $( function() {
                    var range = $("#slider-range");
                    var money = range.data('range');
                    var mi = parseInt(money.split(',')[0]),ma = parseInt(money.split(',')[1]);
                    var cmin = mi,cmax = ma;
                    if(typeof queryParams.price != typeof  undefined){
                        var data = queryParams.price.split('-');
                        cmin = parseInt(data[0].replace(money_format,''));
                        cmax = parseInt(data[1].replace(money_format,''));
                    }
                    range.slider({
                        range: true,
                        min: mi,
                        max: ma,
                        values: [ cmin, cmax ],
                        slide: function( event, ui ) {
                            $( "#amount" ).val(money_format+ ui.values[ 0 ] + "-" + money_format + ui.values[ 1 ]).trigger('change');
                        }
                    });
                    if(cmin != mi || cmax != ma){
                        $( "#amount" ).val(money_format +  $( "#slider-range" ).slider( "values", 0 ) + "-" + money_format + $( "#slider-range" ).slider( "values", 1 ) ).trigger('change');
                    }else{
                        $("#amount").val(money_format + $("#slider-range").slider("values", 0) + "-" + money_format + $("#slider-range").slider("values", 1));
                    }
                });
                $('#amount').on('change',function(){
                    var val = $(this).val();
                    queryParams.price = val;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                })
            }
        },
        initSidebar: function() {
            obj.initFiltresEvent();
        },
        initToolbar: function() {
            obj.initSortbyState();
            obj.initSortbyEvent();
            obj.initPerPageEvent();
            obj.initPaginationEvent();
        },
        initFiltresEvent: function() {
            if ($(".widget-filter").length > 0) {
                var filters = $('.widget input');
                filters.on('change',function(){
                    obj.getValue();
                });
                $('.clear_all').on('click',function(){
                    queryParams.constraint = '';
                    $('.widget input').prop('checked',false);
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                })
            };
        },
        getValue : function(){
            var checked = $('.widget input:checked');
            var query = [];
            checked.each(function(){
                query.push($(this).val());
            });
            queryParams.constraint = query.join('+');
            obj.ajaxClick(obj.getAjaxLink(queryParams));
        },
        initSortbyState: function() {
            if ($("#sort_by").length > 0) {
                if (queryParams.sort_by) {
                    $('#sort_by').each(function() {
                        $(this).val(queryParams.sort_by);
                    });
                }
            }
        },
        initSortbyEvent: function() {
            if ($("#sort_by").length > 0) {
                $(document).find('#sort_by').change(function(event) {
                    var val = $(this).val();
                    queryParams.sort_by = val;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPerPageEvent: function () {
            if ($("#show_qty").length > 0) {
                $("#show_qty").on('change',function(event) {
                    var val = $(this).val();
                    if($(this).find('option:selected').index() == 0) {
                        delete queryParams.view;
                    } else {
                        queryParams.view = val;
                    }
                    delete queryParams.page;
                    obj.ajaxClick(obj.getAjaxLink(queryParams));
                });
            }
        },
        initPaginationEvent: function() {
            if ($(".pagination-product").length > 0) {
                $(".pagination-product a").unbind().click(function(event) {
                    event.preventDefault();
                    if(!$(this).parent().hasClass("active")) {
                        var value = $(this).attr("href").match(/page=\d+/g);
                        if (!value) return false;
                        queryParams.page = parseInt(value[0].match(/\d+/g));
                        obj.ajaxClick(obj.getAjaxLink(queryParams));
                    }
                });
            };
        },
        getAjaxLink: function(value) {
            var page = obj.getUrlSubcategory('/collections/', location.pathname);
            var pathname = '/collections/' + page;
            value = obj.getDecodedUrl(value);
            return value != "" ? pathname + "?" + value : pathname;
        },
        //AJAX
        ajaxClick: function(url) {
            obj.ajaxClickHandlerState = true;
            History.pushState({
                param: Shopify.queryParams
            }, document.title, url);
            obj.getCollectionContent(url);
        },
        getCollectionContent: function(url) {
            var view = url.match(/view=([^&#]*)/);
            if (!view) {
                url += String(url.indexOf('?') > -1 ?'&':'?') + 'view=ajax';
            }
            else {
                view = view[0];
                url = url.replace(view, view+'ajax');
            }

            var params = {
                type: "get",
                url: url,
                beforeSend: function() {
                    obj.showPreloader();
                },
                success: function(data) {
                    obj.hidePreloader();
                    obj.pageData(data);
                    obj.initPaginationEvent();
                },
                error: function(XMLHttpRequest, textStatus) {
                    obj.hidePreloader();
                    alert("error")
                }
            }
            jQuery.ajax(params);
        },
        //Get and show new content
        pageData: function(data) {
            var pagination = ".blog-pagination";
            var products = ".sort-box";
            var result_count = ".result-count";
            $(products).empty();
            $(pagination).empty();
            $(result_count).empty();
            $(result_count).html($(data).find(result_count).html());
            $(products).html($(data).find(products).html());
            $(pagination).html($(data).find(pagination).html());
            theme.featuredCollectionCarousel();
            console.log(queryParams.length);
            if(queryParams.sort_by || queryParams.constraint || queryParams.price){
                $('.clear_all_filter').show();
            }else{
                $('.clear_all_filter').hide();
            }
            obj.filterPrice();
            if($(".spr-badge").length > 0) {
                $.getScript(window.location.protocol + "//productreviews.shopifycdn.com/assets/v4/spr.js");
            }
            $('.currency-picker').trigger('change');
        },
        filterPrice : function(){
            if(typeof queryParams.price != typeof undefined){
                var data = queryParams.price.split('-');
                var cmin = parseInt(data[0].replace(money_format,''));
                var cmax = parseInt(data[1].replace(money_format,''));
                $('.sort-box .col-sm-6').each(function(){
                    var price =  parseInt($(this).find('.sale .money').html().replace('.00','').replace(money_format,'').replace(',',''));
                    if(price < cmin || price > cmax){
                        $(this).hide();
                    }
                })
                $('.blog-pagination .flat-pagination a').each(function(){
                    if($(this).attr('href') != undefined){
                        $(this).attr('href',$(this).attr('href')+'&price='+queryParams.price);
                    }
                })
            }
        },
        //Utils
        showPreloader: function() {
            $(".custom-loader").show();
        },
        hidePreloader: function() {
            $(".custom-loader").hide();
        },
        getUrlSubcategory: function (category, url) {
            var str = url;
            var n = str.indexOf(category);
            if(n < 0)
                return "";
            str = str.slice(n + category.length, str.length);
            var m = str.indexOf("/") > -1 ? str.indexOf("/") : str.length;
            str = str.slice(0, m).toLowerCase();
            return str.replace(name+"=", "");
        },
        getQueryParams: function() {
            var location_path = location.pathname;
            var location_search = location.search;
            var path_search = location_path.split('/');
            path_search.length > 3 ? path_search = 'constraint=' + path_search.pop().replace(/&/g, "") : path_search = location_search.split('?').pop();
            if(path_search == '') return {};
            else return obj.uriToJson(path_search);
        },
        uriToJson: function (value) {
            return JSON.parse('{"' + decodeURI(value.replace(/&/g, "\",\"").replace(/=/g,"\":\"")) + '"}')
        },
        getDecodedUrl: function(value) {
            return decodeURIComponent($.param(value));
        }
    }

    $(document).ready(function() {
        obj.init();
    });

})(jQuery)